import { ThemeInterface, themeNames } from "../theme";
import { colors } from "../../styles/variables";
import {
  FontNames,
  fontWeights,
  FontWeights,
  HexColor,
  textTransform,
} from "@pepdirect/shared/types";

type MtnDewColorNames = "brightGreen" | "darkGray";

const MTN_DEW_COLORS: Record<MtnDewColorNames, HexColor> = {
  brightGreen: "#97d700",
  darkGray: "#171719",
};

const SHARED_HEADING_STYLES = {
  fontFamily: "font-primary" as FontNames,
  fontWeight: "700" as FontWeights,
  color: MTN_DEW_COLORS.darkGray,
  textTransform: textTransform.uppercase,
};

export const MountainDewTheme: ThemeInterface = {
  name: themeNames.MountainDew,
  color: {
    primary: MTN_DEW_COLORS.darkGray,
    secondary: MTN_DEW_COLORS.brightGreen,
    tertiary: MTN_DEW_COLORS.darkGray,
    accent: MTN_DEW_COLORS.darkGray,
    disabled: colors.gray,
    action: colors.green,
    error: colors.red,
    text: colors.mediumGray,
  },
  button: {
    primary: {
      color: MTN_DEW_COLORS.brightGreen,
      textColor: colors.black,
    },
    secondary: {
      color: MTN_DEW_COLORS.brightGreen,
      textColor: colors.black,
    },
    tertiary: {
      color: MTN_DEW_COLORS.darkGray,
      hollow: true,
      solidOnHover: true,
    },
    cancel: {
      color: colors.mediumGray,
      hollow: true,
    },
    error: {
      color: colors.red,
      hollow: true,
    },
    text: {
      color: MTN_DEW_COLORS.darkGray,
    },
    disabled: {
      hollow: true,
    },
    fontWeight: "700",
    borderRadius: "0",
    textTransform: textTransform.uppercase,
  },
  typography: {
    body: {
      color: colors.mediumGray,
    },
    heading: {
      xxl: {
        fontSize: {
          desktop: "56px",
        },
        fontFamily: "font-secondary" as FontNames,
        fontWeight: "700" as FontWeights,
        color: MTN_DEW_COLORS.darkGray,
        textTransform: textTransform.uppercase,
      },
      xl: {
        fontSize: {
          desktop: "36px",
          mobile: "32px",
        },
        ...SHARED_HEADING_STYLES,
      },
      l: {
        fontSize: {
          desktop: "24px",
          mobile: "22px",
        },
        ...SHARED_HEADING_STYLES,
      },
      m: {
        fontSize: {
          desktop: "22px",
          mobile: "22px",
        },
        ...SHARED_HEADING_STYLES,
      },
      s: {
        fontSize: {
          desktop: "20px",
          mobile: "20px",
        },
        ...SHARED_HEADING_STYLES,
      },
      xs: {
        fontSize: {
          desktop: "18px",
          mobile: "18px",
        },
        ...SHARED_HEADING_STYLES,
      },
      xxs: {
        fontSize: {
          desktop: "14px",
          mobile: "14px",
        },
        fontFamily: "font-primary",
        fontWeight: fontWeights[400],
        color: colors.darkGray,
      },
    },
  },
  header: {
    fontWeight: fontWeights[700],
    textTransform: textTransform.uppercase,
    portal: {
      backgroundColor: MTN_DEW_COLORS.darkGray,
      mobileLinkColor: colors.white,
      navLinkOpacity: "1",
    },
    simple: {
      backgroundColor: MTN_DEW_COLORS.darkGray,
    },
  },
  footer: {
    copyright: {
      backgroundColor: MTN_DEW_COLORS.darkGray,
      textColor: colors.white,
    },
  },
  priceAccentColor: MTN_DEW_COLORS.darkGray,
};
